// Compiled at 2026-05-13T13:50:05.286Z
export const $Roles = { "ExpenseManager": "Llama.ExpenseManager" } as const;
